import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { catchError, map } from 'rxjs/operators';
import { AppConfigData } from '../config/appConfigData';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { gateWayModel } from '../../store/GateWay/gateway.model';

@Injectable({
  providedIn: 'root',
})
export class GatewayService {
  constructor(private http: HttpClient, private router: Router) {}

  getgateway(
    pageIndex: number = 1,
    pageSize: number | undefined,
    searchTerm: string = '',
    filter?: string,
    orderBy?: string
  ): Observable<any> {
    let skipValue, topValue;
    if (pageSize) {
      skipValue = pageIndex > 0 && pageSize ? (pageIndex - 1) * pageSize : 0;
      topValue = pageSize || 10000;
    }
    let url =
      `${AppConfigData.getGatewayUrl}?pageIndex=${pageIndex}` +
      `${pageSize ? `&pageSize=${pageSize}` : ''}` +
      `${pageSize == undefined ? `&criteria=${'All'}` : ''}` +
      `${searchTerm && searchTerm.trim() !== ''
        ? `&search=${searchTerm.trim()}`
        : ''
      }` +
      `${filter ? `&${filter}` : ''}` +
      `${orderBy ? `&${orderBy}` : ''}`+
      `${skipValue ? `&$skip=${skipValue}` : ''}` +
      `${topValue ? `&$top=${topValue}` : ''}`;
    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('getMasters failed:', error);
        return throwError(error); // Rethrow the error to propagate it further
      })
    );
  }

  //Create  gateway
  createGateway(gateWayData: any): Observable<any> {
    console.log('userData->', gateWayData);

    return this.http.post<any>(AppConfigData.createGatewayUrl, gateWayData).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('gateWayDataCreation failed:', error);
        return throwError(error); // Rethrow the error to propagate it further
      })
    );
  }

  updateGateway(gatewayData: gateWayModel): Observable<any> {
    return this.http
      .post<any>(AppConfigData.updateGatewayUrl + gatewayData.id, gatewayData)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          console.error('getuserprofile failed:', error);
          return throwError(error); // Rethrow the error to propagate it further
        })
      );
  }

  deleteMaster(id: any): Observable<any> {
    return this.http.post<any>(AppConfigData.deleteGatewayUrl + id, null).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('deleteFaqs failed:', error);
        return throwError(error); // Rethrow the error to propagate it further
      })
    );
  }

  deleteGateway(id: any): Observable<any> {
    return this.http.get<any>(AppConfigData.deleteGateway + id).pipe(
      map((res) => {
        return res;
      }  ),
      catchError((error) => {
        console.error('deleteGateway failed:', error);    
        return throwError(error);
      })
    );
  }

  gateWayOnOff(request: any): Observable<any> {
    const url = `${AppConfigData.gatewayOnOff + request.id}?Status=${
      request.Status
    }`;

    return this.http.post<any>(url, {}).pipe(
      map((res) => res),
      catchError((error) => {
        console.error('gateWayOnOff failed:', error);
        return throwError(() => new Error(error)); // Rethrow the error to propagate it further
      })
    );
  }
}
